const flat = (array, target) => {
  array.forEach(element => {
    if (Array.isArray(element)) flat(element, target);
    else target.push(element);
  });
};

/**
 * @param {Array<Array<T>>} arrays
 * @returns {Array<T>}
 */
export const flatten = array => {
  const flattened = [];

  flat(array, flattened);

  return flattened;
};
